import type { Request } from '../../../index'
import type { ComplexPutParams } from 'app/common/types/food/schools/complexes'

type ParamsApi = {
  photo?: ComplexPutParams['photo'] // опционально, устанавливает фото
  fixed_price_enabled?: boolean // опционально, устанавливает наличие фиксированной цены
  fixed_price?: number // опционально, устанавливает фиксированную цену
  title?: string // опционально, устанавливает новое наименование
  building_id?: number // опционально, задает вариант по корпусу для изменения цены
  diet_food_type_id?: number // опционально, задает вариант по виду диет. питания для изменения цены
  buffet_zone?: boolean // зона буфета
  hot_meals_zone?: boolean // зона горячего питания
  deny_parent_money_sales?: boolean // Не продавать за родительские средства
  deny_more_than_one_sales?: boolean // Не продавать более 1 шт
  disable_for_terminal_guest_sales?: boolean
  use_as_additional?: boolean
  fund_movement_type_code?: number | null // код движения средств
}

export type ComplexResult = {
  id: number
  title: string
  building_id?: number // опционально, задает вариант по корпусу для изменения цены
  diet_food_type_id?: number // опционально, задает вариант по виду диет. питания для изменения цены
  fixed_price_enabled: boolean
  fixed_price?: string
  deletable: boolean
  photo_url: string
  visible: boolean
  buffet_zone: boolean
  hot_meals_zone: boolean
  deny_parent_money_sales: boolean
  deny_more_than_one_sales: boolean
  disable_for_terminal_guest_sales: boolean
  use_as_additional: boolean
}

export type UrlParams = {
  orgId: string
  complexId: string
}

export const convertParams = ({
  orgId,
  complexId,
  photo,
  fixedPriceEnabled,
  fixedPrice,
  title,
  buildingId,
  dietFoodTypeId,
  buffetZone,
  hotMealsZone,
  denyParentMoneySales,
  denyMoreThanOneSales,
  disableForTerminalGuestSales,
  useAsAdditional,
  fundMovementTypeCode,
}: ComplexPutParams): [ParamsApi, UrlParams] => [
  {
    photo,
    fixed_price_enabled: fixedPriceEnabled,
    fixed_price: fixedPrice,
    title,
    building_id: buildingId,
    diet_food_type_id: dietFoodTypeId ? parseInt(dietFoodTypeId, 10) : undefined,
    buffet_zone: buffetZone,
    hot_meals_zone: hotMealsZone,
    deny_parent_money_sales: denyParentMoneySales,
    deny_more_than_one_sales: denyMoreThanOneSales,
    disable_for_terminal_guest_sales: disableForTerminalGuestSales,
    use_as_additional: useAsAdditional,
    fund_movement_type_code: fundMovementTypeCode,
  },
  { orgId, complexId },
]

export const PUT_EDIT_COMPLEX: Request<ComplexPutParams, ComplexResult, UrlParams> = [
  'food/schools/{orgId}/complexes/{complexId}',
  'put',
  ['data', 'complexes'],
]
